// extracted by mini-css-extract-plugin
module.exports = {"root":"Select_root__ILPrD","wrapper":"Select_wrapper__RQ6bR"};